<evi-vertical-menu>
  <evi-vertical-menu-item
    label="Preferences"
    [disabled]="(inspectionInProgress$ | async) ?? false"
    (tgclick)="openPreferenceManager()"
  ></evi-vertical-menu-item>

  @if (hasNetworkSettings) {
    <evi-vertical-menu-item
      label="Network"
      [disabled]="(inspectionInProgress$ | async) ?? false"
      (tgclick)="openNetworkSettings()"
    ></evi-vertical-menu-item>
  }

  @if (featureFlagInspection && featureFlagDeviceManager) {
    <evi-vertical-menu-item
      label="Device Manager"
      (tgclick)="openDeviceManager()"
    ></evi-vertical-menu-item>
  }

  <evi-vertical-menu-item
    label="Readings"
    [disabled]="(inspectionInProgress$ | async) ?? false"
    (tgclick)="openReadingManagers()"
  ></evi-vertical-menu-item>

  @if (featureFlagStatistics && featureFlagAnalysis) {
    <evi-vertical-menu-item
      data-testid="settings-menu-statistics"
      label="Statistics"
      [disabled]="(inspectionInProgress$ | async) ?? false"
      (tgclick)="openStatisticsManagers()"
    ></evi-vertical-menu-item>
  }

  @if (featureFlagAnalysis) {
    <evi-vertical-menu-item
      label="Palettes"
      [disabled]="(inspectionInProgress$ | async) ?? false"
      (tgclick)="openPaletteManager()"
    ></evi-vertical-menu-item>
  }

  @if (hasPerformanceSettings && featureFlagAnalysis) {
    <evi-vertical-menu-item
      label="Performance"
      [disabled]="(inspectionInProgress$ | async) ?? false"
      (tgclick)="openPerformanceModal()"
    ></evi-vertical-menu-item>
  }
</evi-vertical-menu>
